import { ReactNode } from "react";

import Typography from "../../Typography";
import styles from "./styles.module.css";

type ActionCardDescriptionProps = {
  children: ReactNode;
};

const ActionCardDescription = ({ children }: ActionCardDescriptionProps) => {
  return (
    <Typography tag="p" className={styles.description}>
      {children}
    </Typography>
  );
};

ActionCardDescription.displayName = "DS.ActionCard.Description";

export default ActionCardDescription;
